import { i18n } from '@/plugins/i18n'
import { backofficeBranding } from '@/lib/features'

const formatProductName = (product) => {
  if (!product) return ''
  const productTypeKey = `config.productTypes.${product}`
  const productTypeName = i18n.te(productTypeKey) ? i18n.t(productTypeKey) : product
  const override = backofficeBranding?.isActive && backofficeBranding?.config?.productTypeNames?.[product]

  return override || productTypeName
}

export default formatProductName
